import React from "react";
import { Search } from "lucide-react";

export function SearchAndFiltersListing({ searchTerm, onSearchChange, placeholder }) {
  return (
    <div className="card search-filters-card">
      <div className="card-body">
        <div className="row g-3 align-items-center">
          <div className="col-12">
            <div className="position-relative">
              <Search
                size={20}
                className="position-absolute top-50 translate-middle-y ms-3 text-muted"
                style={{ left: "0.5rem" }}
              />
              <input
                type="text"
                className="form-control search-input ps-5"
                placeholder={placeholder || "Search organizations..."}
                value={searchTerm}
                onChange={onSearchChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
